// extracted by mini-css-extract-plugin
export default {"addImageWrapper":"CustomImagePicker_addImageWrapper__JhCmX","addImage":"CustomImagePicker_addImage__XMAoG","addImageText":"CustomImagePicker_addImageText__BCNwV"};